import { Button } from '@mui/material';
import { Box } from '@mui/system';
import { GridColDef } from '@mui/x-data-grid';
import moment from 'moment';
import { useEffect, useState } from 'react';
import TableGridWithFilters from '../../components/TablegridWithFilters/TableGridWithFilters/TableGridWithFilters';
import { interoperabilityDashboardFields } from '../../lib/static/filters/filterFields';
import HttpService from '../../services/HttpService';

const columns: GridColDef[] = [
  {
    field: 'interoperability',
    headerName: 'Διαλειτουργικότητα',
    minWidth: 200,
    sortable: false,
  },
  {
    field: 'audit_user_id',
    headerName: 'Χρήστης',
    minWidth: 200,
    sortable: false,
  },
  {
    field: 'submit_date',
    headerName: 'Ημερομηνία Υποβολής',
    minWidth: 200,
    sortable: false,
    renderCell: (params) => params.row.audit_transaction_date
      ? moment(params.row.audit_transaction_date).format('DD/MM/YYYY, HH:mm:ss').toLocaleString() //'default', { hour12: false } 
      : '-'
  },
  {
    field: 'values',
    headerName: 'Τιμές Αναζήτησης',
    minWidth: 250,
    flex: 1,
    sortable: false,
    renderCell: ({row}) => JSON.stringify(row.values).split(',').join(', ')
  }
];

const initialValues = {
  interoperability_id: '',
  user_id: '',
  dateFrom: '',
  dateTo: ''
};


const Dashboard = () => {
  
  const [interoperabilites, setInteroperabilities] = useState([]);
  const [users, setUsers] = useState([]);

  const getInteroperabilities = async () => {
    const response = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/users-parametrics/interoperabilities`);    
    setInteroperabilities(response.data.interoperabilities);
  };
  const getUsers = async () => {
    const response = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/users?role=internal`);
    setUsers(response.data.data.map((user: any) => {
      return {
        key: `${user.first_name} ${user.last_name}` ,
        value: user.id
      };
    }));
  };

  useEffect(() => {

    getInteroperabilities();
    getUsers();

    return (() => {
      setInteroperabilities([]);
      setUsers([]);
    });
  }, []);

  const downloadFile = async () => {
    const response = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/interoperabilities/download`, {
      responseType: 'arraybuffer',
      // params: eliminateOjectNotTruthyValues(filters),
    });

    const blob = new Blob([response.data], { type: 'application/json' });

    // Create a URL for the blob
    const url = window.URL.createObjectURL(blob);

    // Create a link and click it to download the file
    const link = document.createElement('a');
    link.href = url;
    link.download = 'data.json';
    link.click();

    // Clean up by revoking the object URL
    window.URL.revokeObjectURL(url);
  };

  return (
    <Box my={2}>
      <TableGridWithFilters
        componentInBetween={<Button 
          variant='contained'
          sx={{display: 'flex', ml: 'auto', my: 3}}
          onClick={() => downloadFile()}>
          Λήψη Αποτελεσμάτων Αναζητήσεων
        </Button>}
        title='Φίλτρα Αναζήτησης Διαλειτουργικοτήτων'
        initialValues={initialValues}
        filterFields={interoperabilityDashboardFields(interoperabilites, users)}
        resetFilters
        fetchUrl={`${process.env.REACT_APP_BACKEND_URL}/interoperabilities`}
        columns={columns}
        paginationMode='server'
        sortingMode='server'
        rowsPerPageOptions={[15,25,50]}
      />
    </Box>
  );
};

export default Dashboard;